import React from "react";
import Modal from "../../../../components/ui/Modal/Modal";
import TempTableCheckInventory from "./TempTableCheckInventory";

function PopupNoData() {
  return (
    <span>
      연동 가능한 재고가 없습니다.
      <br />
      스마트팩토리에서 <span className="text-[#e80000]">필수 data 항목</span>
      (카테고리, REF, LOT, QR번호, 제조일자,
      <br />
      유효일자, 입고수량)이 모두 등록된 상태인지 확인해주세요.
      <br />
      최종 업데이트시간에 맞춰, API data를 확인해 주시기 바랍니다.
    </span>
  );
}

function PopupDataExist() {
  return (
    <span>
      스마트팩토리에서 연동된 'API 연동 목록'이 업데이트 되었습니다. <br />
      연동 상태에서는 연동된 결과를 보여줍니다.
    </span>
  );
}

function EmptyState() {
  return (
    <div className="flex flex-col items-center gap-6 justify-center text-[#999999]">
      <span>스마트팩토리 연동을 눌러주세요.</span>
      <p className="mr-[15rem]">
        <span className="font-bold">※ 사용방법 안내</span>
        <br />
        <ul>
          <li className="my-1">
            1. 전제조건 <br />
            <span className="ml-3">
              * 스마트팩토리 연동을 하기위해서는 먼저, 스마트팩토리에
              카테고리-REF에 연동된, QR정보+입고수량 정보를 업로드해주세요.{" "}
            </span>
            <br />
            <span className="ml-3 text-[#e80000]">
              * 필수 data 항목 : 카테고리, REF, LOT, QR번호, 제조일자, 유효일자,
              입고수량
            </span>
          </li>
          <li className="my-1">
            2. 매일 일정한 시간에 스마트팩토리에 업로드 한 입고수량 정보를
            임플란트 Admin 서버에 일괄 업데이트 합니다.
          </li>
          <li className="my-1">
            3. 스마트팩토리에서 정보를 등록한 다음, Admin 서버에 일괄 업데이트
            시간이 지난 후, '스마트팩토리 연동' 버튼을 눌러주세요.
          </li>
          <li className="my-1">
            4. 미연동 상태에서 '스마트팩토리 연동' 버튼을 누르면, 스마트팩토리
            API와 임플란트 Admin 서버와 연결되어 data가 등록되어{" "}
            <span className="text-[#0054ff]">'연동'상태</span>가 됩니다.
          </li>
          <li className="my-1">
            5. 단, 서버간 data 연결만 하는 과정이기때문에{" "}
            <span className="text-[#e80000]">입고재고를 연동</span>
            하기위해선{" "}
            <span className="text-[#0054ff]">
              '재고 상세내역'에서 LOT 재고 연동
            </span>
            을 해주세요.
          </li>
          <li className="my-1">
            6. 연동상태에서 스마트팩토리 연동 버튼을 누르면, 스마트팩토리에서
            서버로 업데이트된 재고정보를 확인할 수 있습니다.
          </li>
        </ul>
      </p>
    </div>
  );
}

function InventoryDetail(props) {
  const data = [
    {
      id: 1,
    },
    {
      id: 2,
    },
  ];

  const isEmpty = data?.length === 0;

  return (
    <div className="">
      <div className="px-6">
        <div className="bg-primary-blue p-3 w-full text-white mt-4">
          상품정보
        </div>
        <div>
          <div className="flex items-center">
            <div className="flex items-center w-1/2">
              <div className="border border-primary-grey bg-[#f2f2f4] p-3 w-[160px] flex-none">
                카테고리
              </div>
              <div className="border-t border-y border-r border-primary-grey bg-white p-3 w-full">
                Category name
              </div>
            </div>
            <div className="flex items-center w-1/2">
              <div className="border-y border-r border-primary-grey bg-[#f2f2f4] p-3 w-[160px] flex-none">
                REF(상품코드)
              </div>
              <div className="border-t border-y border-r border-primary-grey bg-white p-3 w-full">
                상품코드입력란
              </div>
            </div>
          </div>

          <div className="flex items-center ">
            <div className="border-x border-b border-primary-grey bg-[#f2f2f4] p-3 w-[160px] flex-none">
              상품명
            </div>
            <div className="border-b border-r border-primary-grey bg-white p-3 w-full">
              공백 포함 65자 이내 공백 포함 65자 이내 공백 포함 65자 이내 공백
              포함 65자 이내 공백 포함 65자 이 내
            </div>
          </div>
        </div>
      </div>

      <div className="flex px-6 items-center gap-4 mt-4">
        <span className="font-bold">스마트팩토리 API 연동 상태</span>
        <div className="bg-[#f2f2f4] py-1 px-4 rounded-[4px] flex gap-2 items-center">
          <div className="p-2 rounded-full bg-[#0054ff]"></div>
          <span className="font-bold text-sm">연동</span>
        </div>
        <span className="font-bold">최종 업데이트일</span>
        <span>2023.06.01 23:59:59</span>
      </div>
      <Modal
        description={isEmpty ? <PopupNoData /> : <PopupDataExist />}
        hasCancel={false}
      >
        <div className="px-6">
          <div className="bg-[#f2dca8] p-3 text-black w-full mt-4 flex justify-center font-bold cursor-pointer rounded-[4px]">
            스마트팩토리 연동 (업데이트 시간에 신규 재고 확인 가능)
          </div>
        </div>
      </Modal>
      <div className="h-2 bg-[#eeeeee] w-full mt-4" />
      <div className="mt-8">
        {isEmpty ? <EmptyState /> : <TempTableCheckInventory />}
      </div>
    </div>
  );
}

export default InventoryDetail;
